import React, { ReactElement } from "react";
import * as app from '../services/AppService'
//@ts-ignore
import  bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js' 
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';

interface DropdownProps extends RowItem, InterfaceComponentsProps {
    options?: any[],
    data?: any[],
    itemClass?: string,
    placeholder?: string,
    value?: string,
    elmKey?: string | number,
    isTable?: boolean,
    autoClose?: string,
    sNclicked?:(...args:any) => any
    children?: ReactElement[] | any,
    faIcon?: string,
    faSize?: string,
}

function DropdownButton(props: DropdownProps) {

    function closeMenu(e:React.MouseEvent<HTMLUListElement>) {
        //@ts-ignore
        if (e && e.target && e.target.classList && e.target.classList.contains("dropdown-item")) return;
        let toggleBtn = document.getElementById((props.id ||"dropdown").toString())
        if (toggleBtn) {
            let dropdownEl = new bootstrap.Dropdown(toggleBtn);
            dropdownEl.hide();
        }
    }

    const dropdownEl = (
        <div className={"btn-group d-block " + props.class}>
            <button
                className={`btn btn-sm dropdown-toggle ${props.labelClass}`}
                data-bs-auto-close={props.autoClose}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id={(props.id ||"dropdown").toString()}
            >
                {app.translate(props.label)}
                {props.icon && <span className={`iconssc-${props.icon}`}></span>}
                {props.faIcon && <span className={`${props.faIcon} fs-${props.faSize}`}></span>}
            </button>
            <ul
                className={"dropdown-menu bg-light-subtle p-1 " + props.itemClass}
                aria-labelledby="dropdownMenuButton"
                onClick={closeMenu}
            >
                {props.children ?
                    Array.isArray(props.children) && props.children?.[0]?.type == "li"
                        ? props.children
                        : <li>{props.children}</li>
                    :
                    props.options!.map((item, index) => (
                        <li key={index}>
                            <button
                                className="dropdown-item fw-bold"
                                style={{ fontSize: "12px" }}
                                onClick={() => props.sNclicked!(item[props.elmKey!], props.data || [])}
                            >
                                {item[props.value!]}
                            </button>
                            <hr className="m-0 dropdown-divider" />
                        </li>
                    ))
                }
            </ul>
        </div>
    );
    return props.iconTooltip ? (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <TooltipElm style={{ position: "fixed" }} id={`tooltip-dropdown-${props.id}`}>
                    {app.translate(props.iconTooltip)}
                </TooltipElm>
            }
        >
            {dropdownEl}
        </OverlayTrigger>
    ) : dropdownEl
}

DropdownButton.defaultProps = {
    options: [],
    data: [],
    disabled: false,
    label: '',
    class: '',
    labelClass: 'btn-primary ',
    itemClass: ' mx-1 p-1 ',
    value: "Value",
    elmKey: "Key",
    autoClose: "auto",
    table: false,
}
export default DropdownButton;